"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _findLastIndex = _interopRequireDefault(require("unmutable/lib/findLastIndex"));

var _identity = _interopRequireDefault(require("unmutable/lib/identity"));

var _last = _interopRequireDefault(require("unmutable/lib/last"));

var _take = _interopRequireDefault(require("unmutable/lib/take"));

var _pipe = _interopRequireDefault(require("unmutable/lib/util/pipe"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var _composeWith = _interopRequireDefault(require("unmutable/lib/util/composeWith"));

var _Errors = require("../errors/Errors");

var _CancelActionMarker = require("./CancelActionMarker");

var _delete2 = _interopRequireDefault(require("../parcelData/delete"));

var _deleteSelfWithMarker = _interopRequireDefault(require("../parcelData/deleteSelfWithMarker"));

var _insertAfter2 = _interopRequireDefault(require("../parcelData/insertAfter"));

var _insertBefore2 = _interopRequireDefault(require("../parcelData/insertBefore"));

var _map2 = _interopRequireDefault(require("../parcelData/map"));

var _move2 = _interopRequireDefault(require("../parcelData/move"));

var _pop2 = _interopRequireDefault(require("../parcelData/pop"));

var _push2 = _interopRequireDefault(require("../parcelData/push"));

var _setMeta2 = _interopRequireDefault(require("../parcelData/setMeta"));

var _setSelf = _interopRequireDefault(require("../parcelData/setSelf"));

var _shift2 = _interopRequireDefault(require("../parcelData/shift"));

var _swap2 = _interopRequireDefault(require("../parcelData/swap"));

var _swapNext2 = _interopRequireDefault(require("../parcelData/swapNext"));

var _swapPrev2 = _interopRequireDefault(require("../parcelData/swapPrev"));

var _unshift2 = _interopRequireDefault(require("../parcelData/unshift"));

var _update = _interopRequireDefault(require("../parcelData/update"));

var actionMap = {
  delete: function _delete(_ref) {
    var lastKey = _ref.lastKey;
    return (0, _delete2.default)(lastKey);
  },
  insertAfter: function insertAfter(_ref2) {
    var lastKey = _ref2.lastKey,
        value = _ref2.value;
    return (0, _insertAfter2.default)(lastKey, value);
  },
  insertBefore: function insertBefore(_ref3) {
    var lastKey = _ref3.lastKey,
        value = _ref3.value;
    return (0, _insertBefore2.default)(lastKey, value);
  },
  map: function map(_ref4) {
    var updater = _ref4.updater;
    return (0, _map2.default)(updater);
  },
  move: function move(_ref5) {
    var lastKey = _ref5.lastKey,
        moveKey = _ref5.moveKey;
    return (0, _move2.default)(lastKey, moveKey);
  },
  pop: function pop() {
    return (0, _pop2.default)();
  },
  push: function push(_ref6) {
    var values = _ref6.values;
    return _push2.default.apply(void 0, (0, _toConsumableArray2.default)(values));
  },
  setData: function setData(parcelData) {
    return function () {
      return parcelData;
    };
  },
  setMeta: function setMeta(_ref7) {
    var meta = _ref7.meta;
    return (0, _setMeta2.default)(meta);
  },
  set: function set(_ref8) {
    var value = _ref8.value;
    return (0, _setSelf.default)(value);
  },
  shift: function shift() {
    return (0, _shift2.default)();
  },
  swap: function swap(_ref9) {
    var lastKey = _ref9.lastKey,
        swapKey = _ref9.swapKey;
    return (0, _swap2.default)(lastKey, swapKey);
  },
  swapNext: function swapNext(_ref10) {
    var lastKey = _ref10.lastKey;
    return (0, _swapNext2.default)(lastKey);
  },
  swapPrev: function swapPrev(_ref11) {
    var lastKey = _ref11.lastKey;
    return (0, _swapPrev2.default)(lastKey);
  },
  unshift: function unshift(_ref12) {
    var values = _ref12.values;
    return _unshift2.default.apply(void 0, (0, _toConsumableArray2.default)(values));
  }
};
var parentActionMap = {
  delete: true,
  insertAfter: true,
  insertBefore: true,
  move: true,
  swap: true,
  swapNext: true,
  swapPrev: true
};
var stepMap = {
  get: function get(_ref13, next) {
    var key = _ref13.key;
    return (0, _update.default)(key, next);
  },
  md: function md(_ref14, next) {
    var updater = _ref14.updater;
    return (0, _pipe.default)(updater, next);
  },
  mu: function mu(_ref15, next) {
    var updater = _ref15.updater,
        changeRequest = _ref15.changeRequest;
    return function (prevData) {
      var nextData = next(prevData);
      return updater(nextData, changeRequest && changeRequest._create({
        prevData: prevData,
        nextData: nextData
      }));
    };
  }
};

var doAction = function doAction(_ref16) {
  var keyPath = _ref16.keyPath,
      type = _ref16.type,
      payload = _ref16.payload;
  var fn = actionMap[type];

  if (!fn) {
    throw (0, _Errors.ReducerInvalidActionError)(type);
  }

  return fn((0, _objectSpread2.default)({}, payload, {
    lastKey: (0, _last.default)()(keyPath)
  }));
};

var doDeepAction = function doDeepAction(action) {
  var steps = action.steps,
      type = action.type;
  var isParentAction = !!parentActionMap[type];

  if (isParentAction) {
    if (action.keyPath.length === 0) {
      return type === "delete" ? _deleteSelfWithMarker.default : (0, _identity.default)();
    }

    var lastGetIndex = (0, _findLastIndex.default)(function (step) {
      return step.type === 'get';
    })(steps);
    steps = (0, _take.default)(lastGetIndex)(steps);
  }

  return _composeWith.default.apply(void 0, (0, _toConsumableArray2.default)(steps.map(function (step) {
    return function (next) {
      var fn = stepMap[step.type];

      if (!fn) {
        throw (0, _Errors.ReducerInvalidStepError)(step.type);
      }

      return fn(step, next);
    };
  })).concat([doAction(action)]));
};

var _default = function _default(changeRequest) {
  return function (parcelData) {
    var cancelled = 0;
    var actions = changeRequest.actions;

    var newParcelData = _pipeWith.default.apply(void 0, [parcelData].concat((0, _toConsumableArray2.default)(actions.map(function (action) {
      return function (parcelData) {
        try {
          return doDeepAction(action)(parcelData);
        } catch (e) {
          if ((0, _CancelActionMarker.isCancelledError)(e)) {
            cancelled++;
            return parcelData;
          }

          throw e;
        }
      };
    }))));

    return cancelled > 0 && cancelled === actions.length ? undefined : newParcelData;
  };
};

exports.default = _default;